import { Link } from 'react-router-dom';

export default function Footer(){
  return (
    <footer>
      <div className="foot-top">
        <div>
          <div className="foot-brand">
            <img className="brand-logo brand-logo-light" src="/nomad-compass-logo-light.png" alt="Nomad Compass" width="600" height="411" />
          </div>
          <p className="foot-tag">Human visa assistance for the globally mobile. One flat fee, one expert, start to approval.</p>
          <address className="foot-address">
            Nomad Compass<br />
            4 Barham Court, Church Lane,<br />
            Bromley, United Kingdom, BR2 8LA<br />
            <a href="tel:+447412814745">+44 7412 814745</a>
          </address>
        </div>
        <div className="foot-col">
          <h4>Explore</h4>
          <Link to="/countries">Countries</Link>
          <Link to="/quiz">Visa Quiz</Link>
          <Link to="/nomad-index">Nomad Index</Link>
          <Link to="/blog">Journal</Link>
          <Link to="/#why">Why us</Link>
          <Link to="/#faq">FAQ</Link>
        </div>
        <div className="foot-col">
          <h4>Popular visas</h4>
          <Link to="/countries/portugal">Portugal D8</Link>
          <Link to="/countries/spain">Spain DNV</Link>
          <Link to="/countries/united-arab-emirates">Dubai Virtual Working</Link>
          <Link to="/countries/italy">Italy DNV</Link>
          <Link to="/countries/costa-rica">Costa Rica Rentista</Link>
        </div>
        <div className="foot-col">
          <h4>Contact</h4>
          <a href="/#enquiry">Send an enquiry</a>
          <a href="mailto:hello@nomadcompasshub.com">hello@nomadcompasshub.com</a>
          <a href="tel:+447412814745">+44 7412 814745</a>
          <a href="/#enquiry">Book a free call</a>
        </div>
      </div>
      <div className="foot-bottom">
        <div>© 2026 Nomad Compass · Visa assistance service, not a law firm.</div>
        <div>nomadcompasshub.com</div>
      </div>
    </footer>
  );
}
